export const FETCH_INVOICES_RESOLVED = 'FETCH_INVOICES_RESOLVED';
export const FETCH_INVOICES_FAILED = 'FETCH_INVOICES_FAILED';
export const FETCH_INVOICE_RESOLVED = 'FETCH_INVOICE_RESOLVED';
export const FETCH_INVOICE_FAILED = 'FETCH_INVOICE_FAILED';
export const ISSUE_INVOICE_RESOLVED = 'ISSUE_INVOICE_RESOLVED';
export const LINK_INVOICE_ORDER_RESOLVED = 'LINK_INVOICE_ORDER_RESOLVED';
export const ADD_INVOICE_EXTRA_FEE_RESOLVED = 'ADD_INVOICE_EXTRA_FEE_RESOLVED';
export const FETCH_CUSTOMER_AVAILABLE_BALANCE_RESOLVED = 'FETCH_CUSTOMER_AVAILABLE_BALANCE_RESOLVED';
export const FETCH_ELIGIBLE_ORDERS_RESOLVED = 'FETCH_ELIGIBLE_ORDERS_RESOLVED';
export const ATTACH_INVOICE_TO_ORDER_RESOLVED = 'ATTACH_INVOICE_TO_ORDER_RESOLVED';
export const FETCH_ORDER_LINKED_INVOICES_RESOLVED = 'FETCH_ORDER_LINKED_INVOICES_RESOLVED';
export const FETCH_INVOICE_LOGS_RESOLVED = 'FETCH_INVOICE_LOGS_RESOLVED';
